export default __webpack_public_path__ + "static/media/the_hollywood.4557c7ec.jpg";